module.exports = __webpack_public_path__ + "img/lark.c2f8f6dd.png";